import { render, staticRenderFns } from "./Refresh.vue?vue&type=template&id=5a971134"
import script from "./Refresh.vue?vue&type=script&lang=ts"
export * from "./Refresh.vue?vue&type=script&lang=ts"
import style0 from "./Refresh.vue?vue&type=style&index=0&id=5a971134&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports